// @flow

import { type CardBrand } from '@tectonics/prs/card-brand';

import amex from './credit-card-amex.svg';
import carnet from './credit-card-carnet.svg';
import codensa from './credit-card-codensa.png';
import diners from './credit-card-diners.svg';
import discover from './credit-card-discover.svg';
import elo from './credit-card-elo.svg';
import hipercard from './credit-card-hipercard.svg';
import mastercard from './credit-card-mastercard.svg';
import meeza from './credit-card-meeza.svg';
import rupay from './credit-card-rupay.svg';
import visa from './credit-card-visa.svg';
import cabal from './credit-card-cabal.svg';
import credimas from './credit-card-credimas.svg';
import naranja from './credit-card-naranja.svg';
import magna from './credit-card-magna.svg';
import privateLabel from './private-label.svg';
import vr from './card-vr.svg';
import vrMultibeneficios from './card-vr-multibeneficios.svg';
import verveImageSrc from './verve.svg';

export function getImageSourceFromBrand(brand: CardBrand): string {

  switch (brand) {
    case 'amex': return amex;
    case 'carnet': return carnet;
    case 'diners': return diners;
    case 'discover': return discover;
    case 'elo': return elo;
    case 'hipercard': return hipercard;
    case 'mastercard': return mastercard;
    case 'visa': return visa;
    case 'cabal': return cabal;
    case 'credimas': return credimas;
    case 'naranja': return naranja;
    case 'magna': return magna;
    case 'private': return privateLabel;
    case 'codensa': return codensa;
    case 'vr': return vr;
    case 'vr-multibeneficios': return vrMultibeneficios;
    case 'meeza': return meeza;
    case 'rupay': return rupay;
    case 'verve': return verveImageSrc;
    default:
      throw new Error(`OpenedPage: Not supported card brand: ${brand}`);
  }
}
